package dev.danko.roblox_craft_ai.uikit.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.danko.roblox_craft_ai.uikit.icons.AppIcon
import dev.danko.roblox_craft_ai.uikit.icons.Icon
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button

class IconOption<T>(val value: T, val icon: AppIcon, val label: String, val hint: String)

/** A small labelled group of icon buttons (icon over a short word); the longer hint shows as a tooltip. */
@Composable
fun <T> IconChoices(title: String, options: List<IconOption<T>>, selected: T, enabled: Boolean = true, onSelect: (T) -> Unit) {
    val palette = LocalAppTheme.current.colors
    Column(Modifier.gap(4.px)) {
        SpanText(title, Modifier.fontSize(11.px).fontWeight(FontWeight.SemiBold).color(palette.textSecondary))
        Row(Modifier.gap(4.px).styleModifier { property("role", "radiogroup") }) {
            options.forEach { option ->
                val isSelected = option.value == selected
                Button(
                    Modifier.width(68.px).height(62.px).padding(4.px).borderRadius(10.px)
                        .border(1.px, LineStyle.Solid, if (isSelected) palette.accent else palette.borderStrong)
                        .backgroundColor(if (isSelected) palette.accent.toRgb().copy(alpha = 40) else Colors.Transparent)
                        .color(if (isSelected) palette.textPrimary else palette.textSecondary)
                        .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
                        .opacity(if (enabled) 1.0 else 0.6)
                        .styleModifier { property("font-family", "inherit") }
                        .onClick { if (enabled) onSelect(option.value) }
                        .toAttrs {
                            attr("type", "button")
                            attr("role", "radio")
                            attr("aria-checked", isSelected.toString())
                            attr("aria-label", "${option.label}: ${option.hint}")
                            attr("title", "${option.label} — ${option.hint}")
                            if (!enabled) attr("disabled", "")
                        }
                ) {
                    Column(Modifier.fillMaxWidth().gap(3.px), horizontalAlignment = Alignment.CenterHorizontally) {
                        Box(Modifier.color(if (isSelected) palette.accent else palette.textSecondary)) { Icon(option.icon, size = 20, strokeWidth = 1.8) }
                        SpanText(
                            option.label,
                            Modifier.fontSize(11.px).fontWeight(FontWeight.SemiBold).fillMaxWidth().lineHeight(1.1)
                                .styleModifier {
                                    property("text-align", "center"); property("overflow", "hidden")
                                    property("display", "-webkit-box"); property("-webkit-line-clamp", "2"); property("-webkit-box-orient", "vertical")
                                }
                        )
                    }
                }
            }
        }
    }
}
